'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FormView = function FormView(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "3",
    width: "11",
    height: "3"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "8",
    width: "18",
    height: "3"
  }), React__default["default"].createElement("rect", {
    x: "16",
    y: "3",
    width: "5",
    height: "3"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "13",
    width: "5",
    height: "3"
  }), React__default["default"].createElement("rect", {
    x: "10",
    y: "13",
    width: "11",
    height: "3"
  }), React__default["default"].createElement("rect", {
    x: "3",
    y: "18",
    width: "11",
    height: "3"
  }));
};

var FormView$1 = iconStyles()(FormView);

module.exports = FormView$1;
